<div class="patient">
  <div class="wrapper">
    

    <!-- ========================== header (start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <div style="display: flex; align-items: center">
          <h1 class="t-title-main" style="width: 20vw">
           Biopsy and Polypectomy Stats for Colonoscopy
          </h1>
          <div class="l-flex l-flex-c t-field t-field-pad" style="margin-left: 2em">
            <label> Type of Report </label>

            <i class="t-sep"></i>

            <select
              class="t-field t-select"
              [(ngModel)]="report"
              (change)="getReport()"
            >
                <option></option>
              <option value="biopsy">Biopsy count</option>
              <option value="biopsy_only">Biopsy only count (no polypectomy)</option>
              <option value="polypectomy">Polypectomy count</option>
              <option value="polypectomy_only">Polypectomy only count (no biopsy)</option>
              <option value="polypectomy_with_biopsy">Polypectomy and/or Biopsy count</option>
              <option value="both">Both Biopsy and Polypectomy count</option>
            </select>
          </div>
        </div>
        
        <span style="margin-left: 1em">
          From
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [max]="enddate"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
              (dateChange)="getReport()"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          Until
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [min]="startdate"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
              (dateChange)="getReport()"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
        </span>
        <div
          style="
            width: 70%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
          "
        >
          
        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
        

        <!-- *ngIf="examList && examList.length && loginService.userType==='admin'" -->
        <img
          style="cursor: pointer; position: absolute; right: 3%; top: 50%; transform: translateY(-50%)"
          matTooltip="Download CSV"
          *ngIf="loginService.userType === 'admin'"
          height="31em"
          src="../../assets/icons/file.svg"
        />
        </div>
    </div>
    </header>

     <main class="l-deashboard">
  <table *ngIf="results && results.length > 0" class="l-table-auto table-bordered">
        <thead>
          <tr class="l-row weightAss-thead">
            <ng-container *ngFor="let param of getParams()">
                <th class="l-th-m table-cell-bordered">{{param}}</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let res of results" class="l-row weightAss-tbody table-row-bordered">
            <ng-container *ngFor="let param of getParams()">
              <td class="l-td-m table-cell-bordered">{{res[param]}}</td>
            </ng-container>
          </tr>
        </tbody>
       </table>
     </main>

    <aside class="l-sidebar l-flex l-column">
      <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

      <!-- user panel (start) -->
      <div class="userPanel">
        <div class="search-patient">       
            <div class="t-field l-flex t-twin-fieldset"> 
            <div class="w100">
              <button class="search-btn"
                matTooltip="Patients"
                routerLink="/patsearch"
              >
                Go Back to Patients
              </button>
            </div>
          </div>
        
        </div>

        
      </div>
      <!-- user panel (end) -->

      <!-- main nav (start) -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- main nav (end) -->
      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
    </div>
</div>